export const serialize = (queryParams) => {
	const params = [];
	for (let param in queryParams) {
		if (Object.prototype.hasOwnProperty.call(queryParams, param)) {
			params.push(
				encodeURIComponent(param) + '=' + encodeURIComponent(queryParams[param])
			);
		}
	}
	return params.length > 0 ? `?` + params.join('&') : '';
};

export const getURLParam = (paramName, href = window.location.href) => {
	const name = paramName.replace(/[[\]]/g, '\\$&');
	const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	const results = regex.exec(href);

	if (!results) {
		return null;
	}
	if (!results[2]) {
		return '';
	}

	return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
